import {getCurrentYear} from '../../utils/commons'
import BesteExpertenwahlLogo from './logo'
import {besteExpertenWahlStylesDE} from './styles'

const baseConfig = {
  domainName: 'besteexpertenwahl' as const,
  domainType: 'eu' as const,
  siteName: 'Beste Expertenwahl',
  logo: <BesteExpertenwahlLogo className="size-8 shrink-0 tablet:size-6" />,
  favicon: '/favicons/besteexpertenwahl.png',
}

const localeConfigs = {
  de: {
    measurementId: 'G-X771EBX3C6',
    camelCaseUrl: 'BesteExpertenwahl.de',
    title: (category: string, count: string) =>
      `${count} Beste ${category} ${getCurrentYear()} in DE | Es gibt einen klaren Gewinner | BesteExpertenWahl.de`,
    description: (_category?: string, _count?: string) =>
      `BesteExpertenWahl.de – Expertenbewertungen zu Tausenden Produkten. Entdecken Sie top-bewertete Artikel zu den günstigsten Preisen – alles an einem Ort!`,
    styles: besteExpertenWahlStylesDE,
  },
}

export const createConfig = (locale: string = 'de') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.de
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
